export enum ThemeTypes {
    LIGHT = 'light',
    DARK = 'dark',
    SYSTEM = 'system',
}

export type ThemeType = keyof typeof ThemeTypes;
